import React from "react";
import { FaStar, FaQuoteLeft } from "react-icons/fa";
import { SITE_CONTENT } from "../content";

const TestimonialSection = () => {
  const { subtitle, title, reviews } = SITE_CONTENT.pages.homePage.testimonials;

  return (
    <section className="bg-[#f5f1e8] text-[#1c2e22] py-24 lg:py-32 relative overflow-hidden" id="testimonials">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10">
        
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#1b4329]/10 text-[#1b4329] text-xs font-bold tracking-[0.25em] uppercase mb-4 border border-[#1b4329]/20">
            {subtitle}
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light font-serif leading-tight text-[#0a1a0f] mb-4">
            {title}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-[#D4AF37] to-[#E8A040] mx-auto rounded-full" />
        </div>

        {/* 3 Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((rev, idx) => (
            <div
              key={idx}
              className="p-8 rounded-3xl bg-white border border-[#e4dcd0] shadow-md hover:shadow-2xl hover:border-[#E8A040] transition-all duration-300 flex flex-col justify-between relative group"
            >
              {/* Quote Icon & 5 Stars */}
              <div>
                <div className="flex items-center justify-between mb-6">
                  <FaQuoteLeft className="text-[#D4AF37] w-8 h-8 opacity-40 group-hover:opacity-80 transition-opacity" />
                  <div className="flex items-center gap-1 text-[#E8A040]">
                    {[...Array(5)].map((_, i) => (
                      <FaStar key={i} className="w-4 h-4 fill-current" />
                    ))}
                  </div>
                </div>

                <p className="text-[#455249] text-base leading-relaxed font-light mb-8 italic">
                  "{rev.quote}"
                </p>
              </div>

              {/* Author and Occasion */}
              <div className="pt-6 border-t border-[#f0eae0]">
                <p className="font-serif font-bold text-base text-[#0a1a0f] leading-snug">
                  {rev.author}
                </p>
                <span className="text-xs text-[#22c55e] font-semibold tracking-wide block mt-1">
                  ✓ Verified Catering Client
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Aggregated Rating Trust Banner */}
        <div className="mt-14 max-w-xl mx-auto p-5 rounded-2xl bg-white/70 border border-[#e2d9cc] text-center flex items-center justify-center gap-4">
          <div className="flex text-[#E8A040] gap-1">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} className="w-5 h-5 fill-current" />
            ))}
          </div>
          <p className="text-sm text-[#38463c] font-medium">
            <strong className="text-[#0a1a0f]">5.0 / 5.0 Star Rating</strong> based on outdoor wedding, corporate & party catering events in Tamil Nadu.
          </p>
        </div>

      </div>
    </section>
  );
};

export default TestimonialSection;
